import React from 'react';
import { Loader } from '@uberall/zenit';

import styles from './select-account-body.module.css';
import SelectAccountSection from '../select-account-section';
import GoogleProfileSection from '../google-profile-section';
import { MainContentContainer } from '../../main-content-container';

type SelectAccountBodyProps = {
    isGrantAccessRequestPending: boolean;
};

const SelectAccountBody = ({ isGrantAccessRequestPending }: SelectAccountBodyProps) => {
    if (isGrantAccessRequestPending) {
        return (
            <MainContentContainer className={styles.content}>
                <span data-testid="select-account-body-loader" aria-label="loading">
                    <Loader className={styles.loader} />
                </span>
            </MainContentContainer>
        );
    }

    return (
        <MainContentContainer className={styles.content}>
            <SelectAccountSection />
            <hr className={styles.horizontalLine} />
            <GoogleProfileSection />
        </MainContentContainer>
    );
};

export default SelectAccountBody;
